import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiOutlineChevronRight, HiOutlineHome } from 'react-icons/hi2';

const pathNames = {
    'hizmetler': 'Hizmetler',
    'cozumler': 'Çözümler',
    'hakkimizda': 'Hakkımızda',
    'iletisim': 'İletişim',
    'destek': 'Destek',
    'bulut': 'Bulut Hizmetleri',
    'dijital-donusum': 'Dijital Dönüşüm',
    'emurone': 'EmurOne',
    'hpc': 'HPC',
    'dis-kaynak': 'Dış Kaynak',
    'ozel-bulut': 'Özel Bulut Sunucu',
    'felaket-kurtarma': 'Felaket Kurtarma',
    'danismanlik': 'Danışmanlık',
    'haas': 'Donanım Kiralama',
    'eaas': 'Uzman Kiralama',
    'cdn': 'CDN',
    'veritabani': 'Veritabanı',
    'pentest': 'Penetrasyon Testi',
    'monitoring': 'Monitoring',
    'waf': 'WAF & Load Balancer',
    'network': 'Network',
    'lisans': 'Lisans Kiralama',
    'storage': 'Storage',
    'iaas': 'IaaS',
    'paas': 'PaaS',
    'saas': 'SaaS',
    'yardim-masasi': 'Yardım Masası',
    'sanal-veri-merkezi': 'Sanal Veri Merkezi',
    'yonetilen-servisler': 'Yönetilen Servisler',
    'guvenlik': 'Siber Güvenlik',
    'veri-merkezi': 'Veri Merkezi',
    'yedekleme': 'Yedekleme',
    'mail': 'Mail Çözümleri',
    'startup': 'Startup Çözümleri',
    'gelistirme-test': 'Geliştirme & Test',
    'yerinde-destek': 'Yerinde Destek',
    'parca-tedarik': 'Parça Tedarik',
    'kvkk': 'KVKK Danışmanlığı',
};

function Breadcrumb() {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    if (pathSegments.length === 0) return null;

    return (
        <nav className="breadcrumb" aria-label="Breadcrumb">
            <div className="container">
                <ol className="breadcrumb-list">
                    <li className="breadcrumb-item">
                        <Link to="/"><HiOutlineHome size={14} /> Anasayfa</Link>
                    </li>
                    {pathSegments.map((segment, idx) => {
                        const path = '/' + pathSegments.slice(0, idx + 1).join('/');
                        const isLast = idx === pathSegments.length - 1;
                        const name = pathNames[segment] || segment;
                        return (
                            <li className="breadcrumb-item" key={idx}>
                                <HiOutlineChevronRight size={12} className="breadcrumb-sep" />
                                {isLast ? (
                                    <span className="breadcrumb-current">{name}</span>
                                ) : (
                                    <Link to={path}>{name}</Link>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </div>
        </nav>
    );
}

export default Breadcrumb;
